import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AssociatedVMs,
  Fingerprint,
  Type,
} from '../../../../Components/MetadataField/MetaGridFields';

export const KeyPairMetadata: FC = () => {
  const { resourceDetails } = useActiveResourceContext();
  const { data: resource } = resourceDetails;

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields />
      {AssociatedVMs(resource)}
      {Type(resource)}
      {Fingerprint(resource)}
    </Grid>
  );
};
